import { lazy } from 'react';

import { ALLOWED_ROLES } from '@src/packages/utils';

import { PATHS } from './constants';

const WorkOrderList = lazy(() => import('./screens/WorkOrderList'));
const WorkOrder = lazy(() => import('./screens/WorkOrder'));

const routesRoutes = [
  {
    component: WorkOrder,
    path: PATHS.CREATE_ORDER_BY_TEMPLATE,
    writeOnly: true,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.WORK_ORDER.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: WorkOrder,
    path: PATHS.CREATE_ORDER,
    writeOnly: true,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.WORK_ORDER.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: WorkOrderList,
    path: PATHS.BASE_URL,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.WORK_ORDER.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
